

import React from 'react';

const ReadMore = () => (
  <div className="container margin-top-xs-40 margin-top-60 margin-bottom-xs-0 margin-bottom-sm-100">
    <div className="row">
      <div className="col-xs-12">
        <h2 className="text-color-dark-slate text-weight-black margin-top-0 margin-bottom-40 text-size-xs-28 text-size-sm-42 text-align-center">
          READ <span className="text-color-blue">MORE</span>
        </h2>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-6 col-gutter-xs-0 col-gutter-sm-15 text-align-center margin-bottom-xs-10 margin-bottom-sm-0">
        <a href="https://blog.parkwhiz.com/" className="background-color-blue background-color-hover-blue padding-60 display-block">
          <h3 className="text-color-white text-size-24 text-weight-bold margin-top-0">BLOG</h3>
          <p className="text-color-white text-size-16 text-weight-book margin-bottom-0">
            Announcements, interesting insights, helpful tips, and more musings on all things parking.
          </p>
        </a>
      </div>
      <div className="col-sm-6 col-gutter-xs-0 col-gutter-sm-15 text-align-center margin-bottom-xs-10 margin-bottom-sm-0">
        <a href="https://www.arrive.com/about" className="background-color-blue background-color-hover-blue padding-60 display-block">
          <h3 className="text-color-white text-size-24 text-weight-bold margin-top-0">ABOUT US</h3>
          <p className="text-color-white text-size-16 text-weight-book margin-bottom-0">
            Meet our team and learn how you can partner with us.
          </p>
        </a>
      </div>
    </div>
  </div>
);

export default ReadMore;
